import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import Resources from '@constants/resourses';

import { SessionService } from '@services/session.service';
import { TealiumUtagService } from '@services/utag.service';

@Component({
  selector: 'app-error-handling-dialog',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './error-handling-dialog.component.html',
  styleUrl: './error-handling-dialog.component.scss'
})
export class ErrorHandlingDialogComponent {

  id: string = '';
  tealiumData: any = this.sessionService.getItemFromSession(Resources.SessionStorageKeys.TealiumData);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ErrorHandlingDialogComponent>,
    private sessionService: SessionService,
    private tealiumService: TealiumUtagService,
    private router: Router
  ) {
    this.tealiumData['page_name'] = 'EnquiryPresentation';
    // Construct the dialog ID using Tealium data
    this.id = this.tealiumData['app_name'] + '_' + this.tealiumData['page_name'] + '_QuotesError';
  }

  // This method is used to close the dialog
  cancelDialog(target?: string): void {
    this.dialogRef.close(!!target ? target : '');
  }

  // Navigate to home page
  navigateToHome(): void {
    // Trigger Tealium event
    this.tealiumData['event_category'] = 'QuotesError';
    this.tealiumData['event_label'] = 'navigateToHome';
    this.tealiumService.linkEvent(this.tealiumData);
    // clear session and local storage
    this.sessionService.clearSessionStorage();
    this.sessionService.clearLocalStorage();

    this.router.navigate(['/']);
    // Close the dialog and navigate to home
    this.dialogRef.close('navigateToHome');
  }
}
